import axios, { AxiosError, AxiosResponse } from "axios";
import { readToken } from "../services/localStorage.Service";
import {
  User,
  UserWithProjectResponse,
  UserWithProjects,
} from "../domaine/userModel";

export interface UserBody {
  prenom: string;
  nom: string;
  email: string;
  telephone: string;
  role: "admin" | "controleur" | "visiteur";
  password: string;
}

const apiUrl = process.env.REACT_APP_API_URL;

export const axiosInstance = axios.create({
  baseURL: apiUrl,
});

axiosInstance.interceptors.request.use((config: any) => {
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${readToken()}`,
  };
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error(
        "HTTP error response:",
        error.response.data || "No response data available"
      );
      return Promise.reject(error.response.data);
    } else if (error.request) {
      // The request was made but no response was received
      console.error("HTTP no response:", error.request);
      return Promise.reject({
        message: "No response received from the server",
      });
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error("HTTP request setup error:", error.message);
      return Promise.reject({ message: "Error setting up the request" });
    }
  }
);
export const fetchUsersApi = async (apiUrl: string): Promise<User[]> => {
  try {
    const response: AxiosResponse<User[]> = await axiosInstance.get<any>(
      apiUrl
    );
    return response.data;
  } catch (error: any) {
    console.error("Fetch users failed", error);
    throw error.response?.data || "Fetch users failed";
  }
};

export const addUserApi = async (
  newUser: UserBody,
  apiUrl: string
): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.post<any>(
      apiUrl,
      newUser
    );
    return response.data;
  } catch (error: any) {
    console.error("Add user failed", error);
    throw error.response?.data || "Add user failed";
  }
};

export const deleteUserApi = async (
  UserId: number,
  apiUrl: string
): Promise<void> => {
  try {
    await axiosInstance.delete<void>(`${apiUrl}${UserId}/`);
  } catch (error: any) {
    console.error("Delete user failed", error);
    throw error.response?.data || "Delete user failed";
  }
};

export const updateUserApi = async (
  UserId: number,
  newUser: UserBody,
  apiUrl: string
): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.put<any>(
      `${apiUrl}/${UserId}/`,
      newUser
    );
    return response.data;
  } catch (error: any) {
    console.error("Uppdate user failed", error);
    throw error.response?.data || "Uppdate user failed";
  }
};

export const fetchUsersWithProjectsApi = async (
  apiUrl: string
): Promise<any> => {
  try {
    const response: AxiosResponse<UserWithProjectResponse> =
      await axiosInstance.get<UserWithProjectResponse>(apiUrl);
    return response.data;
  } catch (error: any) {
    console.error("Fetch users with projects failed", error);
    throw error.response?.data || "Fetch users with projects failed";
  }
};


export const addBrouillonApi = async (
  formState: any,
  currentStep: number
): Promise<any> => {
  try {
    const response = await axiosInstance.post("/brouillon/create/", {
      form_state: formState,
      current_step: currentStep,
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to add brouillon", error);
    throw error.response?.data || "Failed to add brouillon";
  }
};

export const getBrouillonApi = async (): Promise<any | null> => {
  try {
    const response = await axiosInstance.get("/brouillon/");
    return response.data; // Retourne null si le brouillon n'existe pas
  } catch (error: any) {
    console.error("Failed to fetch brouillon", error);
    throw error.response?.data || "Failed to fetch brouillon";
  }
};


export const resetBrouillonApi = async (): Promise<void> => {
  try {
    await axiosInstance.delete("/brouillon/");
  } catch (error: any) {
    console.error("Failed to reset brouillon", error);
    throw error.response?.data || "Failed to reset brouillon";
  }
};


